const w = window

import jQuery from 'jquery'
import 'jquery.easing'
import 'bootstrap'
import './plugins/pagescroll.js'
import './plugins/scrollevent.js'
import './plugins/loadhtml.js'
import './plugins/togglemenu'

const $ = w.jQuery = jQuery
const url = location.pathname
w.load = {
  'init': new $.Deferred,
  'mapscript': new $.Deferred
}
/****************************
 * モジュールごとのJS読み込みと実行
 */
import HOME   from './module/home'
import WORKS  from './module/works'
import ABOUT  from './module/about'

if(url=='/') HOME()

if(/^\/works\/(.*)?/.test(url)) WORKS()
if(/^\/aboutus\/(.*)?/.test(url)) ABOUT()


// Google Tag manager
;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(w,document,'script','dataLayer','GTM-WDS8GFD');

$(()=>{

  /****************************
   * 郵便番号検索ボタン
   */
  $('[data-plugin=ajaxzip]').on('click',()=>{
    AjaxZip3.zip2addr('zip','','addr','addr'); // eslint-disable-line no-undef
    return false;
  });

  w.load.init.resolve()
});

// 読み込みクラス処理
document.documentElement.classList.remove('no-js')
$(w).on('load',()=>{
  $('body').removeClass('loading')
})